import {
  AlertCircle,
  AlertTriangle,
  AlignLeft,
  Archive,
  ArchiveRestore,
  ArrowDown01,
  ArrowDown10,
  ArrowDownAZ,
  ArrowDownNarrowWide,
  ArrowDownWideNarrow,
  ArrowDownZA,
  ArrowLeft,
  ArrowRight,
  ArrowUpDown,
  BadgeCheck,
  Ban,
  BellRing,
  BookDashed,
  BookUser,
  Building,
  Calendar,
  Check,
  CheckCircle,
  CheckCircle2,
  ChevronDown,
  ChevronUp,
  CircleAlert,
  Clock,
  Contact,
  Download,
  Edit,
  Ellipsis,
  ExternalLink,
  Eye,
  FileText,
  FileX2,
  Gift,
  GripVertical,
  HelpCircle,
  Info,
  LoaderCircle,
  Lock,
  LogOut,
  Map,
  MapPin,
  Menu,
  Minus,
  NotebookPen,
  Package,
  PanelRightClose,
  PanelRightOpen,
  Paperclip,
  Pencil,
  Plus,
  PlusCircle,
  Save,
  Search,
  Star,
  SquareChevronRight,
  SquareKanban,
  Tag,
  Trash,
  Trash2,
  Truck,
  User,
  Users,
  X,
  XCircle,
} from 'lucide-angular';

export const lucideIcons = {
  AlertCircle,
  AlertTriangle,
  AlignLeft,
  Archive,
  ArchiveRestore,
  ArrowDown01,
  ArrowDown10,
  ArrowDownAZ,
  ArrowDownNarrowWide,
  ArrowDownWideNarrow,
  ArrowDownZA,
  ArrowLeft,
  ArrowRight,
  ArrowUpDown,
  BadgeCheck,
  Ban,
  BellRing,
  BookDashed,
  BookUser,
  Building,
  Calendar,
  Check,
  CheckCircle,
  CheckCircle2,
  ChevronDown,
  ChevronUp,
  CircleAlert,
  Clock,
  Contact,
  Download,
  Edit,
  Ellipsis,
  ExternalLink,
  Eye,
  FileText,
  FileX2,
  Gift,
  GripVertical,
  HelpCircle,
  Info,
  LoaderCircle,
  Lock,
  LogOut,
  Map,
  MapPin,
  Menu,
  Minus,
  NotebookPen,
  Package,
  PanelRightClose,
  PanelRightOpen,
  Paperclip,
  Pencil,
  Plus,
  PlusCircle,
  Save,
  Search,
  Star,
  SquareChevronRight,
  SquareKanban,
  Tag,
  Trash,
  Trash2,
  Truck,
  User,
  Users,
  X,
  XCircle,
};
